export enum ErrorCode {
  Unknown = 0,
  ValidationFailed = 1,
  InvalidPermission = 2,
  InvalidToken = 3,
  TokenRevoked = 4,
  InvalidData = 5,
  EmailUnconfirmed = 6,
  EntityDoesNotExist = 7,
  ConfirmationTokenInvalid = 8,
  EmailAlreadyTaken = 9,
  FailedIdentity = 10,
  EmailAlreadyConfirmed = 11,
  IncorrectPassword = 12,
  ServiceNotProvided = 13,
  InvalidApiResponse = 14,
  FailedMapping = 15,
  CriticalError = 16,
  TimeoutError = 17,
}
